module.exports = __webpack_public_path__ + "static/media/296735.a4e5545e.png";